import { wellnub } from '../wellnub.api';

export const signIn = credentials =>
  wellnub.post('/v1/auth/login?role=partner', credentials);

export const resetPassword = email =>
  wellnub.post('/v1/auth/tempPassword', email);
